$( function() {
	$('.btn-vote').on('click', function(e) {
		e.preventDefault();

		var url = $(this).attr('href');
		$.post(url, function(modal) {
			$('.modal-wrapper').remove();
			$(modal).appendTo('body').find('.modal').append( $('<i class="fal fa-times btn-close"></i>') ).on('click', '.btn-close', function(e) {
				e.preventDefault();
				$('.modal-wrapper').remove();
			});
		}, 'html');
	});
});